/*************************************************/
/* PRODUCT WHEEL                                 */
/*************************************************/

export function productWheel() {
    var gfronts = document.querySelectorAll('.g-front');
    var gbacks = Array.from(document.querySelectorAll('.g-back'));
    var activeClass = "active";
    var hideTextClass = "product-wheel__list-container--hidden";

    const init = function () {
        gfronts.forEach(g => {
            g.addEventListener('click', e => {
                var isActive = g.classList.contains(activeClass);
                const buttonId = g.id;
                const button = document.querySelector('button[id="' + buttonId + '"]');
                const textContainer = document.querySelector(".product-wheel__list-container");

                gfronts.forEach(front => {
                    front.classList.remove(activeClass);
                });

                gbacks.forEach(back => {
                    back.classList.remove(activeClass);
                });

                if (!isActive) {
                    g.classList.add(activeClass);
                    if (window.innerWidth < 992) {
                        window.scrollTo(0, textContainer.closest(".product-wheel__list").offsetTop - 300);
                    }

                    const back = gbacks.find(x => x.id.includes(g.id));
                    back.classList.add(activeClass);
                    textContainer.classList.add(hideTextClass);
                } else {
                    textContainer.classList.remove(hideTextClass);
                }

                if (button) {
                    button.click();
                }
            });
        });
    }

    init();
}
